/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { Location, LocationFields } from '@touchplan/common';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';

export class LocationList
	extends FancyFirebaseSplitDataList<LocationFields, DefaultSplitDataRenderType, Location>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const location = new Location(action.payload.key);
		location.databaseUpdate(action.payload.val());
		return location;
	}
	public $$updated(child: Location, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	//put in interface so you can explicitly say you're doing this
	public applyJoinData(baseKey: string, child: Location, otherChild: any) {
		switch (baseKey) {
			case 'locationColor':
				child.view.color = otherChild ? otherChild.color || otherChild.view.color : null;
				break;
			default:
				break;
		}
	}
	public getDataForKey(baseKey: string, child: Location) {
		return child.view[baseKey];
	}
}
